import { useCurrentUser } from '@artic/api-client';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import { usePartnerName } from '../features/inbox/use-partner-name';

export function SentryIdentity() {
  const { user, activePartner } = useCurrentUser();
  const partnerName = usePartnerName();

  useEffect(() => {
    const name =
      user.profile_name ??
      [user.profile_first_name, user.profile_last_name].filter(Boolean).join(' ');
    Sentry.setUser({
      id: user.id,
      ...(user.email ? { email: user.email } : {}),
      ...(name ? { username: name } : {}),
    });
  }, [user.id, user.email, user.profile_name, user.profile_first_name, user.profile_last_name]);

  useEffect(() => {
    Sentry.setTag('partner_key', activePartner);
    Sentry.setTag('partner_name', partnerName);
  }, [activePartner, partnerName]);

  return null;
}
